import PageLayout from "components/layout/PageLayout"

const { useTranslation } = require("react-i18next")
const { useGetPrivacyPolicyQuery } = require("./api/privacyPolicyApiSlice")

export default function PrivacyPolicy() {

    const [t] = useTranslation("global")

    // API
    const {
        data: privacyPolicy,
        isFetching,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch,
    } = useGetPrivacyPolicyQuery()

    let content

    if (isSuccess) {
        content = 
        <div className="mb-4 p-3 bg-dark rounded">
                <span style={{whiteSpace: "pre-line"}}>{privacyPolicy.text}</span>
            </div>
    }


    return <PageLayout
        pageTitle="Privacy Policy"
        bodyContent={content}
        onPageRefresh={refetch}
        isError={isError}
        errorMsg={error}
        isLoadingPage={isLoading}
        isLoadingContent={isFetching}
    />
}

